"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.getNotifications = getNotifications;
exports.nextTokenSelector = void 0;
exports.readNotification = readNotification;
exports.watchNotificationsEventChannel = watchNotificationsEventChannel;
var _reduxSaga = require("redux-saga");
var _effects = require("redux-saga/effects");
var _subject = _interopRequireDefault(require("../services/subject"));
var actions = _interopRequireWildcard(require("../actions"));
var _pubsub = _interopRequireDefault(require("../services/pubsub"));
var _KeyValueDB = _interopRequireDefault(require("../services/KeyValueDB"));
var _snacks = require("../services/snacks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const nextTokenSelector = state => state.notifications.nextToken;
exports.nextTokenSelector = nextTokenSelector;
function* watchNotificationsEventChannel() {
  const channel = (0, _reduxSaga.eventChannel)(emitter => {
    const unsubscribeRNS = _pubsub.default.subscribe(actions.UPDATE_NOTIFICATION_SUCCESS, payload => {
      emitter(actions.updateNotificationSuccess(payload.notification));
    });
    const unsubscribeRANS = _pubsub.default.subscribe(actions.READ_ALL_NOTIFICATIONS_SUCCESS, () => {
      emitter(actions.readAllNotificationsSuccess());
    });
    return () => {
      unsubscribeRNS();
      unsubscribeRANS();
    };
  });
  while (true) {
    const message = yield (0, _effects.take)(channel);
    yield (0, _effects.put)(message);
  }
}
function* getNotifications(action) {
  try {
    const notificationsAPI = yield (0, _effects.getContext)('notificationsApi');
    const nextToken = yield (0, _effects.select)(nextTokenSelector);
    const {
      nextPageToken,
      notifications
    } = yield (0, _effects.call)(notificationsAPI.getItems, action.payload, nextToken);
    yield (0, _effects.put)(actions.getNotificationsSuccess(nextPageToken, notifications || []));
    yield (0, _effects.fork)(watchNotificationsEventChannel);
  } catch (error) {
    const locale = yield (0, _effects.getContext)('locale');
    yield (0, _effects.put)(actions.getNotificationsError(error.message));
    yield (0, _effects.put)(actions.setSnack((0, _snacks.errorSnack)(locale.notificationsAPIError || error.message)));
  }
}
function* readNotification(action) {
  try {
    const notificationsAPI = yield (0, _effects.getContext)('notificationsApi');
    yield (0, _effects.call)(notificationsAPI.readOne, action.payload.notification.ID);
    yield (0, _effects.put)(actions.updateNotificationSuccess(action.payload.notification.ID));
    if (action.meta) {
      yield (0, _effects.call)(action.meta);
    }
    _pubsub.default.publish(actions.UPDATE_NOTIFICATION_SUCCESS, {
      ...action.payload.notification,
      isRead: true
    });
  } catch (error) {
    if (error.response && error.response.status === 409) {
      yield (0, _effects.put)(actions.setSnack((0, _snacks.warnSnack)(action.payload.conflictMsg || error.message)));
    } else {
      yield (0, _effects.put)(actions.setSnack((0, _snacks.errorSnack)(error.message)));
      yield (0, _effects.put)(actions.updateNotificationError(error.message));
    }
  }
}
function* toastInterceptor(action) {
  if (action.meta) {
    if (action.meta.callback) {
      yield (0, _effects.call)(_subject.default.subscribe, {
        payload: action.payload,
        callback: action.meta.callback
      });
    }
    if (action.meta.icon) {
      yield (0, _effects.call)(_KeyValueDB.default.set, action.payload.id, action.meta.icon);
    }
  }
  yield (0, _effects.put)(actions.showToast(action.payload));
}
function* emitActionCallback(action) {
  if (action.meta) {
    yield (0, _effects.call)(_subject.default.notify, action.meta, item => item.payload.id === action.payload.id);
  }
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeLatest)(actions.GET_NOTIFICATIONS_PENDING, getNotifications), (0, _effects.takeLatest)(actions.UPDATE_NOTIFICATION_PENDING, readNotification), (0, _effects.takeEvery)(actions.SET_TOAST, toastInterceptor), (0, _effects.takeEvery)(actions.CLEAR_TOAST, emitActionCallback)]);
}